import type { ApiHandlerContract } from '@sparklayer-io/spark-dash-core/types/handlers/api';
import { buildApis as buildPagesApis } from '@sparklayer-io/spark-dash-pages/api/build-apis';
import type { Apis } from '@sparklayer-io/spark-dash-pages/context/page-context';
import { HomeApi } from '../features/home/api';
import { PlatformApi } from '../features/platform/api';
import { StaffApi } from '../features/staff/api';

/**
 * Composition root for the whole dashboard: everything `pages` builds, plus the apis of the
 * dash-only features. A host hands this to `withPageProviders`, so a page from either package
 * sees the full set.
 */
export function buildApis(apiHandler: ApiHandlerContract): Apis {
  return {
    ...buildPagesApis(apiHandler),
    home: new HomeApi(apiHandler),
    platform: new PlatformApi(apiHandler),
    staff: new StaffApi(apiHandler),
  };
}
